import { useContext, useEffect, useState } from "react";
import { Box, Dialog, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import TrypsLegend from "./components/TrypsLegend";
import LoadingWheel from "../../common/LoadingWheel";
import { GlobalContext } from "../../common/Context";
import { useTranslation } from "react-i18next";
import RenderTrypAccordion from "../../common/RenderTrypAccordion";
import { grey } from "../../../theme/colours";

const Tryps = () => {
  const { t } = useTranslation("Tryps");
  const {
    userState,
    firebaseState,
    desktopView,
    tabletView,
    mobileView,
    userTopTryps,
  } = useContext(GlobalContext);

  const notDesktop = mobileView || tabletView;

  const containerStyle = {
    width: "100%",
    mt: "3%",
  };
  const titleContainerStyle = {
    mb: "2rem",
  };
  const subHeaderStyle = {
    width: desktopView ? "65%" : "100%",
    mt: "0.75rem",
    lineHeight: "1.5",
  };
  const iconStyle = {
    position: "absolute",
    top: "14%",
    right: "8%",
    color: grey[1],
  };
  const modalStyle = {
    "& .MuiPaper-root": {
      width: tabletView ? "55%" : "85%",
      height: "fit-content%",
      borderRadius: "1rem",
    },
  };
  const noTrypsBox = {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "20rem",
    p: "0 2rem",
  };
  const noTryps = {
    fontSize: "1rem",
    textAlign: "center",
  };
  const mapBoxStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "40rem",
    mb: "1rem",
    p: "3%",
    background: "white",
    borderRadius: "1rem",
  };

  const [tryps, setTryps] = useState([]);
  const [map, setMap] = useState("");
  const [mapLoading, setMapLoading] = useState(false);
  const [userLoading, setUserLoading] = useState(true);
  const [legendOpen, setLegendOpen] = useState(false);

  useEffect(() => {
    try {
      const checkProfile = async () => {
        if (userState?.profileID) {
          setMapLoading(true);
          notDesktop
            ? setTryps(userTopTryps)
            : setMap(await firebaseState.getTrypMap(userState.profileID));
          setMapLoading(false);
        } else {
          setTryps([]);
          setMap("");
        }
        setUserLoading(false);
      };
      userState?.profileID && checkProfile();
    } catch (e) {
      setMap("");
    }
  }, [firebaseState, userState, notDesktop]);

  return (
    <Box sx={containerStyle}>
      <Box sx={titleContainerStyle}>
        <Typography variant="h1">{t("myTryps")}</Typography>
        <Typography sx={subHeaderStyle} variant="body2">
          {t("trypsDesc")}
        </Typography>
      </Box>
      {notDesktop && (
        <>
          <InfoIcon sx={iconStyle} onClick={() => setLegendOpen(true)} />
          <Dialog sx={modalStyle} open={legendOpen}>
            <TrypsLegend setOpen={setLegendOpen} />
          </Dialog>
        </>
      )}
      {mapLoading || userLoading ? (
        <Box sx={mapBoxStyle}>
          <LoadingWheel width={6} />
        </Box>
      ) : (
        <>
          {notDesktop ? (
            <>
              {tryps?.length && tryps.length > 0 ? (
                tryps.map((tryp, index) => (
                  <RenderTrypAccordion key={index} tryp={tryp} />
                ))
              ) : (
                <Box sx={noTrypsBox}>
                  <Typography sx={noTryps} color="primary">
                    {t("noTryps")}
                  </Typography>
                </Box>
              )}
            </>
          ) : (
            <Box sx={mapBoxStyle}>
              {map ? (
                <iframe
                  src={map}
                  width="100%"
                  height="100%"
                  title="My Trips"></iframe>
              ) : (
                <Typography variant="h4" color="primary">
                  {t("noDataGetApp")}
                </Typography>
              )}
            </Box>
          )}
        </>
      )}
      {!notDesktop && <TrypsLegend />}
    </Box>
  );
};

export default Tryps;
